var _defs, _rect, _rect2, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    role: "img",
    "aria-label": "Instagram",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "igA",
    cx: "28%",
    cy: "108%",
    r: "115%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FEDA75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "18%",
    stopColor: "#FA7E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "46%",
    stopColor: "#D62976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72%",
    stopColor: "#962FBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#4F5BD5"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 50,
    height: 50,
    rx: 15,
    fill: "url(#igA)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 19,
    width: 26,
    height: 26,
    rx: 8,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 7.2,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40.6,
    cy: 23.4,
    r: 2.5,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.71ab968444d9c708ecc45d1d9bd91528.svg";
export { ForwardRef as ReactComponent };